import React, { useEffect } from 'react';
import './beneficiarios.css';
import { pb2022 } from '../../json/pb2022';

const Pb2022 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'></h3>
          <hr className='hr-gob' />
        </div>
      </div>

      {/* Aqui inicia una seccion */}
      <h5 className='title'>Padrones de Beneficiarios 2023</h5>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Adultos Mayores</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AdultosM/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AdultosM/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AdultosM/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AdultosM/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención a la Juventud</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnJuv/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnJuv/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnJuv/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnJuv/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnMig/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href= 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Migrantes.pdf' //'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnMig/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href= 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Migrantes_PUB_3erTrim_2023.pdf' //'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnMig/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/AtnMig/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/PDB_SUB_OD.pdf' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Padrón de Beneficiarios de Subsidios<br />
                        a Organizaciones Diversas
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/FomArt/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href= 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/FomentoArtesanal.pdf' //'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/FomArt/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href= 'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/padrones/2023/Beneficiarios_X_Conc_Estat_Artesanias_HEH_Jul_2023.pdf' //'https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/FomArt/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/FomArt/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Participación Social</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/PartSoc/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/PartSoc/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/PartSoc/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2023/PartSoc/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
               
               
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>   {/* Aqui temrina una seccion */} 

      {/* Aqui inicia una seccion */}
          <h5 className='title'>Padrones de Beneficiarios 2022</h5>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Adultos Mayores</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AdultosM/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AdultosM/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AdultosM/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AdultosM/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención a la Juventud</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnJuv/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnJuv/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnJuv/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnJuv/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnMig/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnMig/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnMig/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/AtnMig/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/FomArt/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/FomArt/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/FomArt/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/FomArt/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Participación Social</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/PartSoc/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/PartSoc/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/PartSoc/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2022/PartSoc/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
               
               
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>   {/* Aqui temrina una seccion */} 

        {/* Aqui inicia una seccion */}
        <h5 className='title'>Padrones de Beneficiarios 2021</h5>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Adultos Mayores</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AdultosM/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AdultosM/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AdultosM/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AdultosM/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención a la Juventud</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnJuv/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnJuv/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnJuv/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnJuv/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnMig/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnMig/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnMig/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/AtnMig/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/FomArt/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/FomArt/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/FomArt/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/FomArt/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Participación Social</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/PartSoc/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/PartSoc/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/PartSoc/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2021/PartSoc/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
               
               
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>   {/* Aqui temrina una seccion */} 

      {/* Aqui inicia una seccion */}
      <h5 className='title'>Padrones de Beneficiarios 2020</h5>
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
             
              <div style={{ textAlign: 'left' }}>
                
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Adultos Mayores</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AdultosM/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AdultosM/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AdultosM/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AdultosM/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención a la Juventud</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnJuv/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnJuv/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnJuv/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnJuv/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Atención al Migrante</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnMig/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnMig/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnMig/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/AtnMig/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Fomento Artesanal</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/FomArt/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/FomArt/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/FomArt/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/FomArt/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
                <h5 style={{ fontWeight: 'bold', textAlign: 'left' }}>Participación Social</h5>
                <ul style={{ paddingLeft: '20px' }}>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/PartSoc/1T/ENERO-MARZO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Primer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/PartSoc/2T/ABRIL-JUNIO.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Segundo Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/PartSoc/3T/JULIO-SEPTIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Tercer Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                  <li>
                    <strong>
                      <a href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/PB2020/PartSoc/4T/OCTUBRE-DICIEMBRE.xlsx' 
                        target='_blank' 
                        rel="noopener noreferrer" 
                        style={{ fontWeight: 'bold' }} 
                        className='span'
                      >
                        Cuarto Trimestre
                      </a>
                    </strong>
                    <br />                    
                  </li>
                </ul>
               
               
                {/* Añade el resto de los bloques aquí */}
              </div>
            </div>
            
          </div>
        </div>
      </div>   {/* Aqui temrina una seccion */} 

    </div>
  );
};

export default Pb2022;

